// Module
var code = `<div class="rounded-md bg-gray-50 p-4 md:p-6">
  <div class="mb-4">
    <label for="customer" class="mb-2 block text-sm font-medium"
      >{{customerLabel}}</label
    >
    <div class="relative">
      <select
        id="customer"
        name="customerId"
        class="peer block w-full cursor-pointer rounded-md border border-gray-200 py-2 pl-10 text-sm outline-2 placeholder:text-gray-500"
        aria-describedby="customer-error"
        data-slot="customer-options"
      >
        <option value="" disabled selected>{{customerPlaceholder}}</option>
      </select>
      {{svgUserCircle}}
    </div>
    <div
      id="customer-error"
      aria-live="polite"
      aria-atomic="true"
      data-slot="customer-error"
    ></div>
  </div>

  <div class="mb-4">
    <label for="amount" class="mb-2 block text-sm font-medium"
      >{{amountLabel}}</label
    >
    <div class="relative mt-2 rounded-md">
      <div class="relative">
        <input
          id="amount"
          name="amount"
          type="number"
          step="0.01"
          value="{{attrAmount}}"
          placeholder="{{amountPlaceholder}}"
          class="peer block w-full rounded-md border border-gray-200 py-2 pl-10 text-sm outline-2 placeholder:text-gray-500"
          aria-describedby="amount-error"
        />
        {{svgCurrencyDollar}}
      </div>
    </div>
    <div
      id="amount-error"
      aria-live="polite"
      aria-atomic="true"
      data-slot="amount-error"
    ></div>
  </div>

  <fieldset>
    <legend class="mb-2 block text-sm font-medium">{{statusLabel}}</legend>
    <div class="rounded-md border border-gray-200 bg-white px-[14px] py-3">
      <div class="flex gap-4">
        <div class="flex items-center">
          <input
            id="pending"
            name="status"
            type="radio"
            value="pending"
            {{pendingCheckedAttr}}
            class="h-4 w-4 cursor-pointer border-gray-300 bg-gray-100 text-gray-600 focus:ring-2"
          />
          <label
            for="pending"
            class="ml-2 flex cursor-pointer items-center gap-1.5 rounded-full bg-gray-100 px-3 py-1.5 text-xs font-medium text-gray-600"
          >
            {{pendingLabel}} {{svgClock}}
          </label>
        </div>
        <div class="flex items-center">
          <input
            id="paid"
            name="status"
            type="radio"
            value="paid"
            {{paidCheckedAttr}}
            class="h-4 w-4 cursor-pointer border-gray-300 bg-gray-100 text-gray-600 focus:ring-2"
          />
          <label
            for="paid"
            class="ml-2 flex cursor-pointer items-center gap-1.5 rounded-full bg-green-500 px-3 py-1.5 text-xs font-medium text-white"
          >
            {{paidLabel}} {{svgCheck}}
          </label>
        </div>
      </div>
    </div>
    <div
      id="status-error"
      aria-live="polite"
      aria-atomic="true"
      data-slot="status-error"
    ></div>
  </fieldset>

  <div aria-live="polite" aria-atomic="true" data-slot="form-message"></div>
</div>
<div class="mt-6 flex justify-end gap-4">
  <a
    href="{{attrCancelHref}}"
    data-event-type="acmeInvoices"
    data-btn-type="cancel"
    data-event-prevent-default="true"
    class="flex h-10 items-center rounded-lg bg-gray-100 px-4 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-200"
    >{{cancelLabel}}</a
  >
  <button
    type="submit"
    class="flex h-10 items-center rounded-lg bg-blue-500 px-4 text-sm font-medium text-white transition-colors hover:bg-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600"
  >
    {{submitLabel}}
  </button>
</div>
`;
// Exports
module.exports = code;